import React, {useEffect, useState} from 'react'
import homeBanVid from "../../assets/images/home/video/banner-video.mp4"
import { Link } from 'react-router-dom';

function Banner() {


  return (
    <>
        <section className='banner-home'>
            <video src={homeBanVid} autoPlay loop muted className='ban-vid' />
            <div className='caption-banner'>
              <div className='container'>
                  <div className='ban-caption'> 
                      <h1 className='big-ttl'>Empowering Disruptions: <br/> Together, We Reshape the Future.</h1>
                      <p className='sm-para'>Transforming Enterprises and Consumers with Customized Next-Gen Solutions Driven by Innovation.</p>
                      <Link to="/request-a-demo" className='btn'><span>Request for a Demo</span></Link>
                  </div>
              </div>
            </div>
        </section>
    </>
    

  )
}

export default Banner;
